import useAICategoryControl from '@Queries/useAICategoryControl';

import type { BreadcrumbData } from '@divlab/divanui';

const useAIBreadcrumbsForCategory = (breadcrumbs: BreadcrumbData[]) => {
  const {
    sort: { id: sortId },
  } = useAICategoryControl();

  return Number.isFinite(sortId)
    ? breadcrumbs.map((breadcrumb) => {
        if (breadcrumb.link && breadcrumb.link.includes('category')) {
          const url = new URL(breadcrumb.link, window.location.origin);
          url.searchParams.set('sort', sortId.toString());
          return {
            ...breadcrumb,
            link: `${url.pathname}${url.search}`,
          };
        }

        return breadcrumb;
      })
    : breadcrumbs;
};

export default useAIBreadcrumbsForCategory;
